export const TermsAndConditions = () => {
  document.title = "My Routine: Build Habits | Terms and Conditions";

  return (
    <div className="min-h-screen bg-base-200 text-base-content px-4 py-10">
      <div className="max-w-3xl mx-auto bg-base-100 shadow-xl rounded-xl p-6 md:p-10">
        <h2 className="text-3xl font-bold text-center mb-8">Terms and Conditions</h2>

        <Section title="Introduction">
          Welcome to <strong>My Routine</strong>! By using our mobile application or website, you agree to these Terms and Conditions. Please read them carefully before continuing to use our services.
        </Section>

        <Section title="Eligibility">You must be at least 13 years old to use this app. If you are under 18, you may only use the app with the involvement of a parent or guardian.</Section>

        <Section title="Accounts and Registration">
          <ul className="list-disc list-inside mt-2">
            <li>To access certain features, you need to create an account with your name, email, and password.</li>
            <li>You are responsible for keeping your login details secure.</li>
            <li>You agree not to share your account with others or use another person’s account without permission.</li>
          </ul>
        </Section>

        <Section title="Payments and Plans">
          <ul className="list-disc list-inside mt-2">
            <li>We offer both a free plan and a paid plan.</li>
            <li>
              Paid plans are processed securely through <strong>Paystack</strong>.
            </li>
            <li>
              Payments are made <strong>monthly in advance</strong>. We do not auto-renew or automatically charge you.
            </li>
            <li>
              When a payment period ends, your account will show as <strong>expired</strong> until you make another payment.
            </li>
            <li>
              If expired, you may continue to use the app with <strong>limited features</strong> and <strong>ads displayed</strong>.
            </li>
            <li>
              <strong>No refunds</strong> are offered once payment has been made.
            </li>
          </ul>
        </Section>

        <Section title="Advertisements">
          <p>
            The free and expired plans include ads served by <strong>Google AdMob</strong> or other partners. By using these plans, you agree to the display of advertisements within the app.
          </p>
        </Section>

        <Section title="User Responsibilities">
          <p>You agree not to:</p>
          <ul className="list-disc list-inside mt-2">
            <li>Use the app for illegal, harmful, or abusive purposes.</li>
            <li>Attempt to reverse-engineer, modify, or disrupt the app.</li>
            <li>Upload or share content that violates the rights of others.</li>
          </ul>
        </Section>

        <Section title="Intellectual Property">
          All content, design, and features of <strong>My Routine</strong> are owned by us. You may not copy, distribute, or reproduce our app or services without permission.
        </Section>

        <Section title="Termination">We reserve the right to suspend or terminate your account if you violate these Terms and Conditions or misuse the app.</Section>

        <Section title="Limitation of Liability">
          <ul className="list-disc list-inside mt-2">
            <li>We make no guarantees that the app will always function without errors or interruptions.</li>
            <li>We are not liable for any loss, damage, or harm resulting from your use of the app.</li>
          </ul>
        </Section>

        <Section title="Changes to Terms">We may update these Terms from time to time. Continued use of the app after updates means you accept the revised terms.</Section>

        <Section title="Contact Us">
          For questions about these Terms, contact us:
          <br />
          <span className="font-semibold">Email:</span>{" "}
          <a href="mailto:uxpress01@gmail.com" className="text-primary hover:underline">
            uxpress01@gmail.com
          </a>
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h4 className="text-lg font-semibold mb-2 border-b border-base-300 pb-1">{title}</h4>
    <div className="text-sm leading-relaxed">{children}</div>
  </div>
);

export default TermsAndConditions;
